/*
 * It needs to expose $.jQuery to let 'videojs-vimeo' to properly work.
 */
import { getJSON } from "jquery";
window["$"] = {
  ...window["$"],
  getJSON: (
    url: string,
    data: JQuery.PlainObject | string,
    success: JQuery.jqXHR.DoneCallback
  ) => getJSON(url, data, success)
};
